// extracted by mini-css-extract-plugin
export var fadePop = "JournalIssueFilter-module--fade-pop--585a2";
export var filterValues = "JournalIssueFilter-module--filterValues--5e388";
export var growHeightIn = "JournalIssueFilter-module--grow-height-in--92a69";